import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// Belt-and-suspenders: also import here so the singleton is guaranteed to be
// configured even if App.tsx import order ever changes. The module is cached
// by the bundler so the init only runs once.
import './i18n'
import App from './App.tsx'
import { initializeGTM } from './utils/gtm/gtm.ts'
import { initializeGoogleAds } from './utils/gtm/google-ads.ts'
import { initializeMetaPixel } from './utils/gtm/meta-pixel.ts'

// Initialize tracking scripts before React renders
initializeGTM()
initializeGoogleAds()
initializeMetaPixel()

const renderApp = () =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )

renderApp()
